import React, { memo } from 'react'
import { appvizerMenu } from '../../data/Menu'
import PopulateMenu from './PopulateMenu'

const AppvizerMenu = ({ toggleMenu, advertiserId, title, onUpdateSize, language }) => {
    return (
        <div className="nav-group show">
            <div className="nav-label" onClick={toggleMenu}>
                {title}
            </div>
            <PopulateMenu menuItems={appvizerMenu} advertiserId={advertiserId} onUpdateSize={onUpdateSize} language={language} />
        </div>
    )
}

export default memo(AppvizerMenu)
